export const capitalizedWords = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getCityCountry = (nameLong) => {
  const addressParts = nameLong.split(',');
  if (addressParts.length === 1) {
    return addressParts[0];
  }
  return `${addressParts[0]}, ${addressParts[addressParts.length - 1]}`;
};